<template>
  <div>
    <div class="container">
      <el-form :inline="true" :model="queryForm" class="query-form">
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="queryForm.createTimeStart"
            type="datetime"
            placeholder="开始时间（必填）"
            :clearable="false"
          >
          </el-date-picker>
          <span class="time-separator">至</span>
          <el-date-picker
            v-model="queryForm.createTimeEnd"
            type="datetime"
            placeholder="结束时间（默认当前时间）"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryForm.userStatus"
            placeholder="全部状态"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button
            type="success"
            :loading="exporting"
            @click="handleExport"
          >
            导出
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        stripe
        v-loading="loading"
        class="tables"
        ref="multipleTable"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="activeName"
          label="活动名称"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="80">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="postName"
          label="职位"
          width="110"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="unitName" label="公司" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="扩展字段" min-width="200">
          <template v-slot="{ row }">
            <div class="extend-data">{{ formatExtendData(row.extendData) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="申请时间"
          show-overflow-tooltip
        >
          <template v-slot="{ row }">
            {{ backName(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="userStatus"
          label="状态"
          width="70"
          show-overflow-tooltip
        >
          <template v-slot="{ row }">
            {{ formFind(row.userStatus) }}
          </template> </el-table-column
        >
        <el-table-column fixed="right" center label="操作" width="90">
          <template slot-scope="scope">
            <div style="text-align: center">
              <span class="menu-button" @click="openEdit(scope.row)"
                >修改状态</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <el-form
        :rules="rules"
        ref="form"
        style="width: 100%"
        :border="true"
        label-width="80px"
        :model="formLabel"
      >
        <el-form-item label="申请状态" prop="userStatus" required>
          <el-select v-model="formLabel.userStatus" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeData">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  ExportUserInfoList,
  GetUserInfoList,
  SetUserStatus,
} from "@/api/tables/tables";
import dayjs from "dayjs";
export default {
  name: "registration",
  components: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      exporting: false,
      type: "add",
      queryForm: {
        createTimeStart: dayjs().startOf("day").toDate(),
        createTimeEnd: null,
        userStatus: null,
      },

      options: [
        {
          value: 0,
          label: "已报名",
        },
        {
          value: 1,
          label: "联系中",
        },
        {
          value: 2,
          label: "有意向",
        },
        {
          value: 3,
          label: "合作成功",
        },
        {
          value: 4,
          label: "放弃合作",
        },
      ],
      formLabel: {
        userStatus: null,
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        userStatus: [
          { required: true, message: "请选择状态", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatExtendData(extendData) {
      if (!extendData) return "-";

      try {
        const data =
          typeof extendData === "string" ? JSON.parse(extendData) : extendData;
        if (!data || typeof data !== "object") return String(extendData);

        const fieldLabels = {
          dinner: "是否参加晚宴",
          registrationChannel: "报名渠道",
          industryNature: "行业性质",
          dealerType: "代理商类型",
        };
        const formatters = {
          dinner: (value) => ({ "1": "是", "0": "否" }[String(value)] || value),
        };
        const entries = Object.entries(data);
        return entries.length
          ? entries
              .map(([key, value]) => {
                const label = fieldLabels[key] || key;
                const formatter = formatters[key];
                const displayValue = formatter ? formatter(value) : value;
                return `${label}：${displayValue ?? "-"}`;
              })
              .join("；")
          : "-";
      } catch (error) {
        return String(extendData);
      }
    },
    formFind(num) {
      // 通过id找到对应的元素的value
      const val = this.options.find((item) => item.value == num);
      if (val) {
        return val.label;
      } else {
        return "不能确定";
      }
    },
    backName(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    getQueryParams() {
      const params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        activeName: "",
        userStatus: this.queryForm.userStatus,
        createTimeStart: dayjs(this.queryForm.createTimeStart).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
      if (this.queryForm.createTimeEnd) {
        params.createTimeEnd = dayjs(this.queryForm.createTimeEnd).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      return params;
    },
    validateQueryTime() {
      const start = this.queryForm.createTimeStart;
      const end = this.queryForm.createTimeEnd || new Date();
      if (!start) {
        this.$message.warning("请选择申请开始时间");
        return false;
      }
      if (dayjs(end).isBefore(dayjs(start))) {
        this.$message.warning("结束时间不能早于开始时间");
        return false;
      }
      if (dayjs(end).isAfter(dayjs(start).add(3, "month"))) {
        this.$message.warning("申请时间范围不能超过三个月");
        return false;
      }
      return true;
    },
    handleSearch() {
      if (!this.validateQueryTime()) return;
      this.currentPage = 1;
      this.getList();
    },
    handleReset() {
      this.queryForm.createTimeStart = dayjs().startOf("day").toDate();
      this.queryForm.createTimeEnd = null;
      this.queryForm.userStatus = null;
      this.currentPage = 1;
      this.getList();
    },
    handleExport() {
      if (!this.validateQueryTime()) return;
      this.exporting = true;
      ExportUserInfoList(this.getQueryParams())
        .then((res) => {
          const contentType = res.headers["content-type"] || "application/octet-stream";
          const blob = new Blob([res.data], { type: contentType });
          const disposition = res.headers["content-disposition"] || "";
          const extensionMatch = disposition.match(/\.([a-z0-9]+)(?:["';]|$)/i);
          const extension = extensionMatch
            ? extensionMatch[1]
            : contentType.includes("csv")
            ? "csv"
            : contentType.includes("spreadsheetml")
            ? "xlsx"
            : contentType.includes("ms-excel")
            ? "xls"
            : "csv";
          const fileName = `报名列表_${dayjs().format("YYYYMMDDHHmmss")}.${extension}`;
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        })
        .catch(() => {
          this.$message.error("导出失败，请稍后重试");
        })
        .finally(() => {
          this.exporting = false;
        });
    },
    getList() {
      this.loading = true;
      GetUserInfoList(this.getQueryParams())
        .then((res) => {
          if (res.data.success) {
            const data = res.data.data;
            const items = Array.isArray(data)
              ? data
              : Array.isArray(data && data.items)
              ? data.items
              : [];
            this.tableData = items;
            const currentCount = (this.currentPage - 1) * this.pageSize + items.length;
            this.total =
              items.length === this.pageSize
                ? currentCount + 1
                : currentCount;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 打开编辑
    openEdit(row) {
      this.type = "edit";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.id = row.id;
        this.formLabel.userStatus = JSON.parse(JSON.stringify(row.userStatus));
      });
    },
    //编辑数据
    changeData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          SetUserStatus({
            id: this.id,
            userStatus: this.formLabel.userStatus,
          }).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "修改成功！",
                type: "success",
              });
              this.loading = true;
              setTimeout(() => {
                this.getList();
              }, 1000);
            } else {
              this.$message.error("失败！");
            }
          });
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.query-form {
  margin-top: 20px;
}

.time-separator {
  margin: 0 10px;
}

.tables {
  margin-top: 10px;
}

.pagination {
  margin-top: 50px;
  text-align: center;
}

.extend-data {
  white-space: normal;
  line-height: 22px;
  overflow-wrap: anywhere;
}

.menu-button {
  color: #2970ec;
  cursor: pointer;
}
</style>
